/**
 * Resolves once `posthog.init()` has actually run. The PostHog init lives in the
 * lazily-loaded `post-hog-provider` chunk, while the analytics provider
 * (`providers/posthog.ts`) registers earlier — so provider methods triggered by
 * `/info` (e.g. `setAnonymousContext`) can otherwise call `posthog.setPersonProperties`
 * before init, which permanently breaks feature-flag loading for that session.
 * Provider methods await this gate before touching posthog.
 */
let resolveReady: (() => void) | undefined;

export const posthogReady: Promise<void> = new Promise<void>((resolve) => {
  resolveReady = resolve;
});

export function markPosthogReady(): void {
  resolveReady?.();
}
